import { useEffect, useState } from 'react';
import type { Guide } from '../games/guides';

/**
 * The game guides are ~400 kB of text. Loading them on demand keeps them out of the main bundle, so the
 * site starts faster on school Chromebooks. scripts/prerender.mjs still writes the full text into every
 * game's page file for search engines.
 */
type GuidesModule = typeof import('../games/guides');
let mod: GuidesModule | null = null;
let pending: Promise<GuidesModule> | null = null;

export function loadGuides(): Promise<GuidesModule> {
  pending ??= import('../games/guides').then((m) => (mod = m));
  return pending;
}

/** The game's guide, or undefined until the guides have loaded (the component re-renders then). */
export function useGuide(id: string): Guide | undefined {
  const [, setLoaded] = useState(mod !== null);
  useEffect(() => {
    if (mod) return;
    let live = true;
    loadGuides().then(
      () => live && setLoaded(true),
      () => {},
    );
    return () => {
      live = false;
    };
  }, []);
  return mod?.guideFor(id);
}
